<template>
    <div class="kleptos-taskbar-wrapper">
        <div class="kleptos-taskbar">

            <!-- START BUTTON -->
            <button
                class="kleptos-taskbar-start-btn"
                :class="{ active: startMenuOpen }"
                @click="startMenuOpen = !startMenuOpen">

                <div class="inner">
                    <img v-if="startMenuOpen" width="17" src="~@/assets/img/taskbar-start-icon--aqua@2x.png" alt="Start Icon">
                    <img v-if="!startMenuOpen" width="17" src="~@/assets/img/taskbar-start-icon--gold@2x.png" alt="Start Icon">
                    <span class="text">Start</span>
                </div>
            </button>

            <!-- PINS -->
            <div class="kleptos-taskbar-pins">
                <button @click.prevent="minimizeWindows" title="Desktop"><i class="fa fa-window-restore"></i></button>
                <!-- <button><i class="fa fa-internet-explorer"></i></button> -->
                <!-- <button><i class="fa fa-envelope"></i></button> -->
            </div>

            <!-- using for data-uuid to query element and get coords for minimize -->

            <!-- MINIMIZED WINDOWS -->
            <div class="kleptos-taskbar-minimized-panels">
                <button
                    class="kleptos-taskbar-panel-btn"
                    :data-uuid="item.uuid"
                    v-for="(item, index) in windows"
                    :class="{ active: item.windowData.minimized }"
                    :key="item.windowData.uuid"
                    :minimized="item.windowData.minimized"
                    @mousedown="minimizeWindow({ target: item, bool: false })"
                    @dblclick="minimizeWindow({ target: item, bool: true })"
                >
                    <i
                        v-if="item.icon"
                        :class="item.icon"
                        class="mr-1"
                    >
                    </i>
                        {{ item.name }}
                </button>
            </div>

            <!-- SYSTEM TRAY -->
            <KleptosSystemTray class="ml-auto" />

        </div> <!-- ./kleptos-taskbar -->

        <!-- START MENU -->
        <KleptosStartMenu
            v-if="startMenuOpen"
            v-on-click-outside="close"
            class="kleptos-start-menu"
        />

    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';
    // https://github.com/kmohrf/vue-on-click-outside
    import { mixin as onClickOutside } from 'vue-on-click-outside';
    import SystemTray from './TaskbarSystemTray';
    import StartMenu from './TaskbarStartMenu';

    export default {
        components: {
            KleptosSystemTray: SystemTray,
            KleptosStartMenu: StartMenu
        },
        mixins: [
            onClickOutside
        ],
        data() {
            return {
                startMenuOpen: false,
            }
        },
        computed: {
            ...mapGetters({
                windows: 'gameOS/getWindows'
            }),
        },
        methods: {
            ...mapActions('gameOS', [
                'minimizeWindow',
                'minimizeWindows'
            ]),
            close(){
                this.startMenuOpen = false;
            }
        }
    }
</script>

<style lang="scss" scoped>

    //------------------------------------------------------
    // WRAPPER
    //------------------------------------------------------

    .kleptos-taskbar-wrapper  {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
    }

    //------------------------------------------------------
    // TASKBAR
    //------------------------------------------------------

    .kleptos-taskbar {
        display: flex; // [LOCKED]
        width: 100%;
        height: rem-calc(40); // [LOCKED]
        background: linear-gradient(to bottom, rgba(#dddccc,1) 0%,rgba(#d1d0c1,1) 100%); // [LOCKED]
        // transform: translateY(100%);
    }

    //------------------------------------------------------
    // START BUTTON
    //------------------------------------------------------

    .kleptos-taskbar-start-btn {
        min-width: rem-calc(100); // [LOCKED]
        // margin-right: 3px;
        margin-right: rem-calc(10);
        border: 0; // [RESET]
        border-right: 1px solid rgba(#a6a392, 0.6);
        background: linear-gradient(to bottom, rgba(lighten(#dddccc, 10%),1) 0%,rgba(#d1d0c1,1) 100%);
        font-size: rem-calc(19);
        font-weight: 500;
        box-shadow: 1px 0 3px 0px rgba(black,0.1);

        .text {
            position: relative;
            top: 1px;
        }

        img { // icon
            margin-right: rem-calc(6);
        }

        &:active,
        &.active {
            background: linear-gradient(to bottom, rgba(darken(#dddccc, 14%),1) 0%,rgba(darken(#d1d0c1, 0%),1) 100%);
            box-shadow: inset 1px 0 3px 1px rgba(black,0.1);

            .inner {
                position: relative;
                top: 1px;
            }
        }
    }

    //------------------------------------------------------
    // PINS
    //------------------------------------------------------

    .kleptos-taskbar-pins {
        display: flex;
        margin-right: rem-calc(8);
        // background: red;

        button {
            border: 0;
            font-size: rem-calc(14);
            color: rgba(darken(#d9d8c8, 60%), 0.5);
            line-height: 0;
            background: none;

            &:hover {
                color: rgba(darken(#d9d8c8, 60%), 0.6);
            }
        }
    }

    //------------------------------------------------------
    // MINIMIZED PANELS
    //------------------------------------------------------

    .kleptos-taskbar-minimized-panels {
        display: flex;
        flex-grow: 1;
        overflow: hidden;
        overflow-x: auto;
        margin-right: 3px; // [LOCKED] - same as above
        // background: red;
        -webkit-overflow-scrolling: auto;
    }

    //------------------------------------------------------
    // MINIMIZED PANEL BUTTONS
    //------------------------------------------------------

    .kleptos-taskbar-panel-btn {
        width: rem-calc(200); // [LOCKED]
        padding: rem-calc(0 12); // [LOCKED]
        margin: rem-calc(4 3); // [LOCKED] - design
        border: 1px solid darken(#a8a595, 1%);
        border-bottom: 1px solid rgba(white, 0.1);
        border-right: 1px solid rgba(white, 0.4);
        background: linear-gradient(to bottom, rgba(lighten(#dddccc, 10%),1) 0%,rgba(lighten(#d1d0c1, 5%),1) 100%); // [LOCKED]
        font-size: rem-calc(14); // [LOCKED]
        font-weight: 500;
        text-align: left;
        white-space: nowrap; // [LOCKED]
        overflow: hidden; // [LOCKED]
        text-overflow: ellipsis; // [LOCKED]

        &.active {
            background: linear-gradient(to bottom, rgba(lighten(#dddccc, 5%),1) 0%,rgba(#d1d0c1,1) 100%); // [LOCKED]
            border: 1px solid white;
            border-bottom: 1px solid darken(#a8a595, 1%);
            border-right: 1px solid darken(#a8a595, 1%);
            font-weight: normal;
        }
    }

    //-----------------------------------------------------------------
    // SCROLLBARS
    //-----------------------------------------------------------------

    /* this targets the default scrollbar (compulsory) */
    ::-webkit-scrollbar {
        height: 6px;
    }

    /* this will style the thumb, ignoring the track */
    ::-webkit-scrollbar-thumb {
        // border-radius: 4px;
        background-color: rgba(black, 0.4);
        border-bottom: 1px solid #d1d0c1;
    }
</style>